import {useState, useEffect} from "react";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

// PORTED TO locationcard.js FOR INLINE EDITING 

function EditLocation({locationInfo, onCancel, update}){

    const [isEditingName, setIsEditingName] = useState(false);
    const [isEditingPostcode, setIsEditingPostcode] = useState(false);
    const [isEditingWebsite, setIsEditingWebsite] = useState(false);
    const [isEditingDescription, setIsEditingDescription] = useState(false);


    const [newName, setNewName] = useState(locationInfo.locationName);
    const [newPostcode, setNewPostcode] = useState(locationInfo.locationPostcode);
    const [newWebsite, setNewWebsite] = useState(locationInfo.locationWebsite);
    const [newDescription, setNewDescription] = useState(locationInfo.locationDescription);

    const {language} = useLanguage();

    const translations = {
        en: {
            locationPhoto: "Location Photo: ",
            locationName: "Location Name: ",
            save: "Save",
            edit: "Edit",
            locationDescription: "Location Description: ", 
            description: "Description",
            locationPostcode: "Location Postcode: ",
            postcode: "Postcode",
            locationWebsite: "Location Website: ",
            Website: "Website",
            Cancel: "Cancel",
               
        },

        gd: {
            locationPhoto: "Dealbh an Àite: ",
            locationName: "Ainm an Àite: ",
            save: "Sàbhail",
            edit: "Deasaich",
            locationDescription: "Tuairisgeul Àite: ", 
            description: "Tuairisgeul",
            locationPostcode: "Còd-puist Àite: ",
            postcode: "Còd-puist",
            locationWebsite: "Làrach-lìn Àite: ",
            Website: "Làrach-lìn",
            Cancel: "Cuir às",
        },
    };

    console.log("Location: ", locationInfo);

    const handleUpdateDetail = async (field, newDetail) => {
        
        console.log("details: ", field, newDetail);

        const payload = {
            field, 
            newDetail, 
            "locationName" : locationInfo.locationName,
        };

        const response = await fetch(`${BASE_URL}/api/update_location_detail/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
      
            body: JSON.stringify(payload),
        });

        if(field === "name"){
            setIsEditingName(false);
            locationInfo.locationName = newDetail;
            update();
        }

        if(field === "description"){
            setIsEditingDescription(false);
            locationInfo.locationDescription = newDetail;
            update();
        }

        if(field === "postcode"){
            setIsEditingPostcode(false);
            locationInfo.locationPostcode = newDetail;
            update();
        }

        if(field === "website"){
            setIsEditingWebsite(false);
            locationInfo.locationWebsite = newDetail;
            update();
        }
    }

    const handlePictureChange = async (e) => {
        const file = e.target.files[0];

        console.log('locationName', locationInfo.locationName);
        
        const formData = new FormData();

        formData.append('locationPicture', file);
        formData.append('locationName', locationInfo.locationName);

        const response = await fetch(`${BASE_URL}/api/update_location_photo/`, {
            method: 'POST',
            body: formData,
        });

        if (response.ok) {
            const data = await response.json();

            locationInfo.locationPicture = data.locationPictureUrl;
            update();
        }


    };

    return(

        <div>

            <div>

                <p>{translations[language].locationPhoto}
                    
                        <img
                            src={locationInfo.locationPicture}
                            alt = "Location Photo"
                        />
                    
                        
                        <input
                            type="file"
                            onChange={handlePictureChange}
                            accept="image/*"
                        />
                    
                    
                </p>

            </div>

            <div>

                <p>{translations[language].locationName}
                    {isEditingName ? (
                        <input
                            type = "text"
                            value = {newName}
                            onChange = {(e) => setNewName(e.target.value)}
                        />
                    ):(
                        locationInfo.locationName
                    )}
                </p>

                    {isEditingName ? (
                        <button onClick={() => handleUpdateDetail("name", newName)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button onClick={() => setIsEditingName(true)}>{translations[language].edit}</button>
                        </>
                    )}
            </div>

            <div>

                <p>{translations[language].locationDescription}
                    {isEditingDescription ? (
                        <textarea
                        value = {newDescription}
                        onChange = {(e) => setNewDescription(e.target.value)}
                        rows = "5"
                        cols = "40"
                        style= {{ width: "100%" }}

                        />
                    ):(
                        locationInfo.locationDescription
                    )}
                </p>

                    {isEditingDescription ? (
                        <button onClick={() => handleUpdateDetail("description", newDescription)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button onClick={() => setIsEditingDescription(true)}>{translations[language].edit}</button>
                        </>
                    )}
            </div>

            <div>

                <p>{translations[language].locationPostcode}
                    {isEditingPostcode ? (
                        <input
                        type = "text"
                        value = {newPostcode}
                        onChange = {(e) => setNewPostcode(e.target.value)}
                        />
                    ):(
                        locationInfo.locationPostcode
                    )}
                </p>

                    {isEditingPostcode ? (
                        <button onClick={() => handleUpdateDetail("postcode", newPostcode)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button onClick={() => setIsEditingPostcode(true)}>{translations[language].edit}</button>
                        </>
                    )}
            </div>

            <div>

                <p>{translations[language].locationWebsite}
                    {isEditingWebsite ? (
                        <input
                        type = "text"
                        value = {newWebsite}
                        onChange = {(e) => setNewWebsite(e.target.value)}
                        />
                    ):(
                        locationInfo.locationWebsite
                    )}
                </p>

                    {isEditingWebsite ? (
                        <button onClick={() => handleUpdateDetail("website", newWebsite)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button onClick={() => setIsEditingWebsite(true)}>{translations[language].edit}</button>
                        </>
                    )}
            </div>

                <div>
                    <button onClick={onCancel}>{translations[language].cancel}</button>
                </div>
        </div>


    );

};

export default EditLocation;